<div class="main-content tpl3pl-layout">
	<ng-container *ngIf="isDashboard">
		<router-outlet></router-outlet>
	</ng-container>
	<div class="container-fluid" *ngIf="!isDashboard">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}">
						<h4 class="card-title">
							<i class="material-icons" (click)="back()">arrow_left</i> {{ pageTitle }}
						</h4>
						<p class="card-category">3PL Integration</p>
					</div>
					<div class="card-body">
						<router-outlet></router-outlet>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
